import { render } from "./MinecraftModPN.vue?vue&type=template&id=2091a67a&scoped=true"
import script from "./MinecraftModPN.vue?vue&type=script&lang=js"
export * from "./MinecraftModPN.vue?vue&type=script&lang=js"

import "./MinecraftModPN.vue?vue&type=style&index=0&id=2091a67a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2091a67a"]])

export default __exports__